import { Component, OnInit, OnDestroy } from '@angular/core';
import { SubscriptionPlansService } from '../services/subscription-plans.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ch-subscription-plans-listing',
  templateUrl: './subscription-plans-listing.component.html',
  styleUrls: ['./subscription-plans-listing.component.css']
})
export class SubscriptionPlansListingComponent implements OnInit, OnDestroy {
  public items = [];
  public totalItems;
  public pageParams: any = {};
  public showArchived: boolean = false;

  public loading: boolean;

  public breadcrumb: string[] = [];

  constructor(private subscriptionPlansService: SubscriptionPlansService, private titleService: Title) {}

  ngOnInit() {
    this.titleService.setTitle(`Subscription Plans | CODE Hospitality CMS`);
    this.loadItems();
    this.breadcrumb = ['Subscription Plans'];
  }

  private loadItems() {
    this.loading = true;
    const handle = result => {
      const jsonData = result.json();
      this.items = jsonData;
      this.totalItems = jsonData.length;
      this.loading = false;
    };

    this.subscriptionPlansService.getAllSubscriptionPlans(this.showArchived).subscribe(handle);
  }

  public toggleShowArchived() {
    this.showArchived = !this.showArchived;
    this.loadItems();
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/subscription-plans/subscription-plans-listing/subscription-plans-listing.component.ts